import { DefaultMetricOptions } from '@griply/types';

// Measured from their own sub-goals, so they add nothing to a flattened sub-goal list until completed.
export const subGoalMeasuredMetricIds: DefaultMetricOptions[] = [
  DefaultMetricOptions.SubGoalProgress,
  DefaultMetricOptions.CompletedSubGoals,
];

// Every metric the app derives rather than letting the user enter a value for.
export const derivedMetricIds: DefaultMetricOptions[] = [
  DefaultMetricOptions.CompletedTasks,
  ...subGoalMeasuredMetricIds,
];

export const isDerivedMetricId = (metricId?: string | null): boolean =>
  !!metricId && derivedMetricIds.includes(metricId as DefaultMetricOptions);

export const isSubGoalMeasuredMetricId = (metricId?: string | null): boolean =>
  !!metricId &&
  subGoalMeasuredMetricIds.includes(metricId as DefaultMetricOptions);
